<template>
  <b-form-select
    size="sm"
    v-model="selectedFile"
    :options="options"
    @change="selectFile()">
    <template #first>
      <option :value="null">--Please select column--</option>
    </template>
    <!-- <option
      v-for="file in files"
      :key="selectedFile"
      :value="file._id">
      {{ file.originalName }}
    </option> -->
  </b-form-select>
</template>

<script>
  import axios from "axios";
  import { fullURL } from "../../utils";
  import { saveProject, fetchActiveProject, updateActiveProject, updateProjectFiles } from "../../store/files";

  export default {
    name: 'DataTypeEntry',
    components: {},
    props: {
      meta: Object,
      files: Array,
      project: Object
    },
    
    data() {
      return {
        tab: 1,
        isSaving: false,
        // projects: this.$store.state.files.projectList,
        selectedFile: (!!this.project.files && !!this.project.files[this.meta.type]) ? this.project.files[this.meta.type] : null
      };
    },

    methods: {
      selectFile() {
        var data = {};
        console.log("Selected File: ", this.selectedFile);
        data['fileID'] = this.selectedFile;
        data['meta'] = this.meta;
        data['project'] = this.project['id'];

        this.isSaving = true;
        this.$store.dispatch(updateProjectFiles(this.project['id'], this.meta.type, this.selectedFile))
          .then(() => {
            // this.onSuccess();
            console.log("Project file update successful!");
          })
          .catch(console.log)
          .finally(() => {this.isSaving = false;});

        this.$emit('select-file', data);
      }
    },

    computed: {
      options() {
        // console.log("Project: ", this.project);
        // console.log("Meta: ", this.meta);
        // console.log("Files: ", this.files);
        var options = [];
        this.files.forEach(file => {
          var option = file;
          option['value'] = file['_id'];
          option['text'] = file['originalName'];
          options.push(option);
        });
        // console.log("Options: ", options);
        return options;
      },

      metaList() {
        return this.$store.state.general.metas;
      },
    }
  };
</script>

